import {
  CustomEventProperties,
  EventDataKey
} from "core/analytics/analytics.types";
import { getContextNameFromUrlBasePath } from "core/analytics/analytics.utils";
import { APP_NAME } from "core/common-types/app.constants";

import { useAccount } from "@azure/msal-react";
import { BpxQueryKeys } from "@bps/blocks-core";
import { useQueryClient } from "@tanstack/react-query";

export const useAccountClaimAnalyticsParams = (): Partial<
  Record<EventDataKey | "userId", string | number | boolean | undefined>
> => {
  const account = useAccount();
  const claims = account?.idTokenClaims;

  return {
    userId: claims?.oid as string,
    tenantId: claims?.bpt as string
  };
};

const useCurrentUserAnalyticsParams = (): CustomEventProperties => {
  const queryClient = useQueryClient();
  const cachedBpxUserModel:
    | {
        isClinicalContributor: boolean;
        isBeta: boolean;
        userRoleText: string;
        userLevel: string;
      }
    | undefined = queryClient.getQueryData(BpxQueryKeys.user.detail());
  if (!cachedBpxUserModel) {
    return {};
  }
  return {
    isClinical: cachedBpxUserModel.isClinicalContributor,
    isBeta: cachedBpxUserModel.isBeta,
    userRole: cachedBpxUserModel.userRoleText,
    userLevel: cachedBpxUserModel.userLevel
  };
};

export const useDefaultAnalyticsParams = () => {
  const claimParams = useAccountClaimAnalyticsParams();
  const userParams = useCurrentUserAnalyticsParams();
  const appContext = getContextNameFromUrlBasePath();

  return { ...claimParams, ...userParams, appId: APP_NAME, appContext };
};
